var IpcSmdPadGeneratorData = require('./ipcSmdPadGeneratorData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var ComponentAttribute = require('./componentAttribute.js');
var EllipseData = require('../../../svg/ellipseData.js');
var SmdPadstackData = require('../../../padstack/smdPadstackData.js');
var PadData = require('../../padData.js');
var IPCRules = require('../ipcRules');
var cio_config = require("cio-config");

var BgaData = function(position, angle, init) {
    IpcSmdPadGeneratorData.apply(this, arguments);

    //total number of pads at top and bottom sides
    this.verticalPadCount = this.value("verticalPadCount", true, cio_config.types.positive_int.validator);

    //terminal types for BGA
    this.terminalType = this.value("terminalType", true);

    this.horizontalPinPitch = this.value("horizontalPinPitch", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.verticalPadCount);
    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalType);
    this.nonTransformedSegmentedGeometry.addTrigger(this.horizontalPinPitch);

    this.update3dModelNonTriggerList.push("terminalType");
};

lib_core.inherit(BgaData, IpcSmdPadGeneratorData);
lib_core.JsonParser.registerClass(BgaData, "BgaData");

module.exports = BgaData;

BgaData.prototype.setupMinMaxPtrMap = function() {
    IpcSmdPadGeneratorData.prototype.setupMinMaxPtrMap.call(this);
    this.validationMap["horizontalPinPitch"] = [this.horizontalPinPitch];
};

BgaData.prototype.getRowNames = function(rowCount) {
    function getNthRowName(n) {
      var name = [];
      var noAlphabets = 26;
      
      while(n >= 1) {
        var m = n % noAlphabets;
        var idx = (m !== 0) ? m : noAlphabets;
        
        if(m === 0) {
          n = parseInt(n / noAlphabets - 1);
        } else {
          n = parseInt(n / noAlphabets)
        }
        
        name.unshift(String.fromCharCode(64 + idx));
      }
      
      return name.join('');
    }

    //BGA row names do not support these letters to avoid confusion of treating these letters as numbers 
    //(e.g., I -> 1, O, Q -> 0, S -> 5, Z -> 2, X -> need input/NA)
    var excludeList = ['I', 'O', 'Q', 'S', 'X', 'Z'];
    var rowNames = [];
    var n = 1;

    while(n <= rowCount) {
        var name = getNthRowName(n);
        var valid = true;

        for(var i = 0; i < excludeList.length; i++) {
            if(name.indexOf(excludeList[i]) !== -1) {
                valid = false;
                break;
            }
        }

        if(valid) {
            rowNames.push(name);
        } else {
            rowCount++; //row names array must contains rowCount number elements
        }

        n++;
    }

    return rowNames;
};

BgaData.prototype.updatePads = function(pads, absolutePositions) {
    var self = this;

    //apply transform on pads if absolute position flag is true
    if (absolutePositions) {
        pads.forEach(function(pad) {
            pad.move(self.pos());
            pad.rotate(self.angle(), self.pos());
        });
    }

    return pads;
};

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
BgaData.prototype.getPads = function(absolutePositions) {
    var pads = [];

    //reset component
    this.component.reset();
    this.component.calculatePadsGeometry(false);

    //if ball diameter is zero dont push pads
    if(this.component.X > 0) {
        var pad,
            motif = this.getMotif(),
            gridRow = this.horizontalPadCount(),
            gridCol = this.verticalPadCount();

        var rowNames = this.getRowNames(gridRow);

        for(var i = 0; i < gridRow; i++) {
            for(var j = 0; j < gridCol; j++) {
                pad = motif.clone();

                //BGA Grid center should be mouse coord or grid should be centerd at origin in editor2d if no placement using mouse
                pad.move(new lib_geometry.Coord(j * this.horizontalPinPitch() - this.horizontalPinPitch() * (gridCol - 1) / 2, -i * this.verticalPinPitch() + this.verticalPinPitch() * (gridRow - 1) / 2));
                
                //update pad name
                pad.name(rowNames[i] + '' + (j + 1));
                pads.push(pad);
            }
        }
    }

    pads = this.updatePads(pads, absolutePositions);
    return pads;
};

BgaData.prototype.getSilkscreen = function(pads) {
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    var body = this.getBodyForSilkscreen();

    ////////////////////
    //   Pin Marker   //
    ////////////////////

    silkscreen.push(this.getPinOneMarker(pads[0], body, true));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////

    //silkscreen offset
    var silkscreenOffset = IPCRules.silkscreenCornerClipPercentage * (Math.min(body.width, body.height));

    //top-left corner
    var pathData = new PathData(new lib_geometry.Coord(-body.width / 2, body.height / 2 - silkscreenOffset), IPCRules.silkscreenStrokeWidth);
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2, body.height / 2), PathType.LINE));
    pathData.addObject(new PathObjectData(new lib_geometry.Coord(-body.width / 2 + silkscreenOffset, body.height / 2), PathType.LINE));
    silkscreen.push(pathData);

    //top-right corner
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.VER, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    //bottom-right corner
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.HOR, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    //bottom-left corner
    pathData = pathData.clone();
    pathData.flip(new lib_geometry.Line(lib_geometry.Line.VER, new lib_geometry.Coord(0, 0)));
    silkscreen.push(pathData);

    return silkscreen;
};

BgaData.prototype.getMotif = function() {
    var shape = new EllipseData(new lib_geometry.Coord(0, 0), 0, 0, 0, true, 0);
    shape.width(this.component.X);
    shape.height(this.component.Y);

    var padstack = new SmdPadstackData(shape, true, false, 101.6, true, false, 0, true);
    var motif = new PadData(new lib_geometry.Coord(0, 0), 0, "__smdPadReplicatorMotif__", padstack, true);
    
    return motif;
};
